module.exports = __webpack_public_path__ + "img/meme_18.3c0d43a6.jpg";